<template>
  <NewsAdmin v-if="isAdminPage" />
  <RashaCorti v-else-if="isRashaCortiPage" />
  <template v-else>
    <NavBar active-profile="andreas" />
    <HomeHero />
    <CurriculumVita />
    <ContactPage ref="#contact" />
    <FooterBar />
  </template>
</template>

<script>
import HomeHero from "./components/HomeHero.vue";
import CurriculumVita from "./components/CurriculumVita.vue";
import NavBar from "./components/Nav.vue";
import ContactPage from "./components/Contact.vue";
import FooterBar from "./components/FooterBar.vue";
import RashaCorti from "./components/RashaCorti.vue";
import NewsAdmin from "./components/NewsAdmin.vue";
export default {
  name: "App",
  components: {
    HomeHero,
    CurriculumVita,
    NavBar,
    ContactPage,
    FooterBar,
    RashaCorti,
    NewsAdmin,
  },
  computed: {
    isAdminPage() {
      return window.location.pathname.replace(/\/$/, "") === "/admin";
    },
    isRashaCortiPage() {
      return window.location.pathname.replace(/\/$/, "") === "/rasha-corti";
    },
  },
  mounted() {
    if (!this.isRashaCortiPage && !this.isAdminPage) {
      this.setAndreasMeta();
    }
  },
  methods: {
    setAndreasMeta() {
      const description = "AJL Corporate Advisors";
      document.title = "KR. Dr. Andreas J. Ludwig";
      this.setMetaTag("name", "description", description);
      this.setMetaTag("property", "og:title", "KR. Dr. Andreas J. Ludwig");
      this.setMetaTag("property", "og:description", description);
      this.setMetaTag(
        "property",
        "og:image",
        "https://ajl-advisors.com/preview.jpg"
      );
    },
    setMetaTag(attribute, key, content) {
      let tag = document.head.querySelector(`meta[${attribute}="${key}"]`);
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute(attribute, key);
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", content);
    },
  },
};
</script>

<style></style>
